if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      // comment this in for js fetch of swatch product into current product card
      this.handleProductCardSwatchClick();
      if(window.innerWidth >= 750) {
        this.setSwatchesListeners();
      }
    }

    handleInsideLinkClick = (event) => {
      event.preventDefault();
    };

    calculateScrollDistance = () => {
      this.swatchGap = parseInt(window.getComputedStyle(this.productSwatches).gap);
      this.swatchWidth = this.swatches[0].offsetWidth;
      this.scrollDistance = (this.swatchWidth + this.swatchGap) * 2;
    }

    setSwatchesListeners = () => {
      this.productSwatchesGroup = this.querySelector("product-group");
      if (!this.productSwatchesGroup) return;
      this.productSwatches = this.productSwatchesGroup.querySelector(".product-group");
      this.swatches = this.productSwatches.querySelectorAll('product-group-swatch');

      this.calculateScrollDistance();

      this.productSwatchesWidth = this.productSwatches.offsetWidth;
      this.productSwatchesGroupArrowLeft = this.querySelector(".swatches-arrow.swatches-arrow--left");
      this.productSwatchesGroupArrowRight = this.querySelector(".swatches-arrow.swatches-arrow--right");

      this.addEventListener("mouseover", this.handleProductSwatchesGroupHover);
      this.addEventListener("mouseout", this.handleProductSwatchesGroupHoverOut);

      this.productSwatchesGroupArrowLeft?.addEventListener("click", this.handleArrowClick);
      this.productSwatchesGroupArrowRight?.addEventListener("click", this.handleArrowClick);

      this.addEventListener("mouseout", () => {
        this.productSwatchesGroupArrowLeft?.classList.remove("show-arrow");
        this.productSwatchesGroupArrowRight?.classList.remove("show-arrow");
      });

      new ResizeObserver(() => {
        this.calculateScrollDistance();
      }).observe(this);
    }

    fetchProduct(event) {
      event.preventDefault();

      const isWithinSlider = this.closest("slider-component") !== null;
      const isWithinCartDrawer = this.closest("#CartDrawer") !== null;
      const isProductPage = document.body.classList.contains("product");
      const isMobile = window.innerWidth < 750;

      /*
        if ((isWithinSlider && isProductPage && isMobile) || (isWithinSlider && isWithinCartDrawer && isMobile)) {
          return
        }
      */

      fetch("/products/" + event.target.dataset.productHandle + "?view=card-product--swatches")
        .then((response) => response.text())
        .then((text) => {
          const newHtml = new DOMParser().parseFromString(text, "text/html").querySelector("product-card").innerHTML;

          if (newHtml !== null) {
            this.innerHTML = newHtml;
            this.handleProductCardSwatchClick();
          }

          this.querySelector('button[data-oos]')?.classList.add('button--oos-visible');
        })
        .catch((e) => {
          console.error(e);
        });
    }

    handleProductCardSwatchClick() {
      const swatches = this.querySelectorAll("product-group product-group-swatch");
      swatches.forEach((swatch) => {
        if(swatch.classList.contains("current-swatch")) return;
        swatch.addEventListener("click", this.fetchProduct.bind(this));
        swatch.querySelector("a.product-group--item")?.classList.add("js-load");
        swatch.querySelector("a.product-group--item")?.addEventListener("click", this.handleInsideLinkClick);
        if(window.innerWidth >= 750) {
          this.setSwatchesListeners();
        }
      });
    }

    shouldShowArrow = () => {
      // if scroll left is 0, hide left arrow and show right arrow
      if(this.productSwatches.scrollLeft === 0 && this.productSwatches.scrollWidth > this.productSwatches.clientWidth) {
        this.productSwatchesGroupArrowLeft?.classList.remove("show-arrow");
        this.productSwatchesGroupArrowRight?.classList.add("show-arrow");
      }

      // if scroll left is not 0, show left arrow and show right arrow
      if(this.productSwatches.scrollLeft !== 0 && this.productSwatches.scrollWidth > this.productSwatches.clientWidth) {
        this.productSwatchesGroupArrowLeft?.classList.add("show-arrow");
        this.productSwatchesGroupArrowRight?.classList.add("show-arrow");
      }

      // if scroll left is at the and there is possible scroll, show left arrow and hide right arrow
      if(this.productSwatches.scrollLeft === this.productSwatches.scrollWidth - this.productSwatches.clientWidth && this.productSwatches.scrollWidth > this.productSwatches.clientWidth) {
        this.productSwatchesGroupArrowLeft?.classList.add("show-arrow");
        this.productSwatchesGroupArrowRight?.classList.remove("show-arrow");
      }
    }

    handleProductSwatchesGroupHover = (event) => {
      if(event.target.closest("product-group") === null) return;
      this.shouldShowArrow();
    }

    handleProductSwatchesGroupHoverOut = (event) => {
      if(event.target.closest("product-group") !== null) return;
      this.productSwatchesGroupArrowLeft?.classList.remove("show-arrow");
      this.productSwatchesGroupArrowRight?.classList.remove("show-arrow");
    }

    handleArrowClick = (event) => {
      if(event.currentTarget?.dataset?.direction === 'right') {
        this.productSwatches.scrollBy({
          left: this.scrollDistance,
          behavior: 'smooth'
        });
      } else {
        this.productSwatches.scrollBy({
          left: -this.scrollDistance,
          behavior: 'smooth'
        });
      }

      setTimeout(() => {
        this.shouldShowArrow();
      }, 250);
    }
  }

  customElements.define("product-card", ProductCard);
}
